
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kvkk",
      function () {
        return require("private-next-pages/kvkk.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kvkk"])
      });
    }
  